import React from 'react';

interface IOwnProps {
    text: string;
}

type Props = IOwnProps;

class MultilineText extends React.Component<Props, {}> {
    public render() {
        const lines = this.props.text.split('\n');

        return lines.map((item, key) => <React.Fragment key={key}>{item}{key === lines.length - 1 ? null : <br />}</React.Fragment>);
    }
}

export default MultilineText;